export interface IMatchingInstructions {
  MatchInst?: number// 1625
  MatchInstMarketID?: string// 1673
  MatchAttribTagID?: string// 1626
  MatchAttribValue?: string// 1627
}
